import { render, staticRenderFns } from "./CreateAnAccount.vue?vue&type=template&id=201f6464"
import script from "./CreateAnAccount.vue?vue&type=script&lang=js"
export * from "./CreateAnAccount.vue?vue&type=script&lang=js"
import style0 from "./CreateAnAccount.vue?vue&type=style&index=0&id=201f6464&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports